import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DISTRIBUTION } from '../../constant';
import type { EmailDistributionPayload } from './sendEmailDistribution';

/**
 * Save an email distribution as a DRAFT (or update an existing draft).
 *
 * Mirrors the MO draft flow: set the recipient up now, send once the report is
 * finalized. Sent records are immutable server-side.
 */
export const saveEmailDraftApi = createAsyncThunk(
  'distribution/saveEmailDraft',
  async (payload: EmailDistributionPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(DISTRIBUTION.EMAIL_SAVE_DRAFT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        return rejectWithValue(result.msg || `Save draft failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
